export const PRICE_IDS = {
  PRICE_ID_PROD: 'price_1OPO1WJ13oII81FIcruZH57l',
  PRICE_ID_DEV: 'price_1OPNj4J13oII81FI2ib4A8U6',
  PRICE_ID_TEST: 'price_1OPNj4J13oII81FI2ib4A8U6',
};
